import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SportFundLogo from "@/components/SportFundLogo";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-slate-900 py-12">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <div className="flex items-center mb-4">
                            <Link to="/"><SportFundLogo className="h-14 w-auto text-white" /></Link>
                        </div>
                        <p className="text-slate-400 text-sm">
                            {t('footer.blurb')}
                        </p>
                    </div>

                    <div>
                        <h3 className="font-bold text-white mb-4">{t('footer.platform')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/how-it-works"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.howItWorks')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/faqs"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.pricing')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/signup-creator"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('actions.getStarted')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-white mb-4">{t('footer.resources')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/resources"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.resourceArticles')}
                                </Link>
                            </li>
                            <li>
                                {/* Static pages (seo/render.py), not an SPA route: a plain link loads them. */}
                                <a
                                    href="/college-sports"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    College sports reports
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/parent-plus"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.parentPlusCalculator')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/faqs"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.faqs')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-white mb-4">{t('footer.company')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/about"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.aboutUs')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.contact')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/privacy"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.privacy')}
                                </Link>
                                {' | '}
                                <Link
                                    to="/terms"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.terms')}
                                </Link>
                                {' | '}
                                <Link
                                    to="/acceptable-use"
                                    className="text-slate-400 hover:text-white transition-colors text-left"
                                >
                                    {t('nav.acceptableUse', 'Acceptable use')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-slate-700 pt-8 text-center text-sm text-slate-400">
                    <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
